import { Controller } from '@hotwired/stimulus'
import { turboFrame, current } from '../helpers'
import { formsProjectTodosetsPath, formsProjectTodosetTodolistsPath } from '../routes'

const TODOSETS_FRAME_ID = 'forms_todosets'
const TODOLISTS_FRAME_ID = 'forms_todolists'

export default class extends Controller {
  static values = { formId: String, projectId: String }

  selectDestination ({ detail: { projectId, target } }) {
    if (target !== 'todolist') return
    this.projectIdValue = projectId
    this.removeTodosets()
    this.removeTodolists()
    if (projectId) this.insertTodosetsFrame(projectId)
  }

  selectTodoset ({ target }) {
    this.removeTodolists()
    if (target.value) this.insertTodolistsFrame(target.value)
  }

  // Private

  insertTodosetsFrame (projectId) {
    const todosetsFrame = turboFrame(
      TODOSETS_FRAME_ID,
      formsProjectTodosetsPath(current.account.id, projectId, { form_id: this.formIdValue }),
      { class: 'block' }
    )
    this.element.appendChild(todosetsFrame)
  }

  insertTodolistsFrame (todosetId) {
    const todolistsFrame = turboFrame(
      TODOLISTS_FRAME_ID,
      formsProjectTodosetTodolistsPath(current.account.id, this.projectIdValue, todosetId, { form_id: this.formIdValue }),
      { class: 'block mt-4' }
    )
    this.element.appendChild(todolistsFrame)
  }

  removeTodosets () {
    document.getElementById(TODOSETS_FRAME_ID)?.remove()
  }

  removeTodolists () {
    document.getElementById(TODOLISTS_FRAME_ID)?.remove()
  }
}
